/**
 * Minimalerei Login-Dropdown — Desktop Hover-Logik
 *
 * Pattern analog zum Megamenu-Hover:
 * - 200ms Open-Delay damit kein Flash beim flüchtigen Drüberfahren
 * - 300ms Close-Delay damit User nicht panicked wenn Maus kurz raus
 * - Mobile (≤989px) ausgeschlossen — auf Touch direkter Link-Klick
 */

(function () {
  'use strict';

  const SELECTOR = '[data-mp-login]';
  const OPEN_DELAY = 200;
  const CLOSE_DELAY = 300;
  const MOBILE_BREAKPOINT = 989;

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  function initLogin(login) {
    let openTimer = null;
    let closeTimer = null;

    const trigger = login.querySelector('[data-mp-login-trigger]');
    const dropdown = login.querySelector('[data-mp-login-dropdown]');

    if (!trigger || !dropdown) return;

    function open() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (login.classList.contains('is-open')) return;
      openTimer = setTimeout(function () {
        login.classList.add('is-open');
      }, OPEN_DELAY);
    }

    function close() {
      if (openTimer) {
        clearTimeout(openTimer);
        openTimer = null;
      }
      closeTimer = setTimeout(function () {
        login.classList.remove('is-open');
      }, CLOSE_DELAY);
    }

    function handleMouseEnter() {
      if (isMobileViewport() || isTouchDevice()) return;
      open();
    }

    function handleMouseLeave() {
      if (isMobileViewport() || isTouchDevice()) return;
      close();
    }

    function handleTriggerClick(event) {
      // Mobile / Touch: Default-Link-Verhalten → navigiert zur href
      if (isMobileViewport() || isTouchDevice()) return;

      // Desktop: Click toggled das Dropdown (gibt Tastatur-Zugang)
      event.preventDefault();

      if (login.classList.contains('is-open')) {
        login.classList.remove('is-open');
      } else {
        if (openTimer) clearTimeout(openTimer);
        if (closeTimer) clearTimeout(closeTimer);
        login.classList.add('is-open');
      }
    }

    function handleDocumentClick(event) {
      if (!login.contains(event.target)) {
        login.classList.remove('is-open');
      }
    }

    function handleKeydown(event) {
      if (event.key === 'Escape' && login.classList.contains('is-open')) {
        login.classList.remove('is-open');
        trigger.focus();
      }
    }

    login.addEventListener('mouseenter', handleMouseEnter);
    login.addEventListener('mouseleave', handleMouseLeave);
    trigger.addEventListener('click', handleTriggerClick);
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleKeydown);
  }

  function initAll() {
    const logins = document.querySelectorAll(SELECTOR);
    logins.forEach(initLogin);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
